/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetOralExamIdPhotoUrlKind = (typeof GetOralExamIdPhotoUrlKind)[keyof typeof GetOralExamIdPhotoUrlKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOralExamIdPhotoUrlKind = {
  document: 'document',
  selfie: 'selfie',
} as const;
